export interface XmlAlacakliBaglami {
    vekaletId: number | null;
    kisiId: number | null;
    kurumId: number | null;
}

function kayitId(deger: unknown): number | null {
    if (typeof deger !== "number" && typeof deger !== "string") return null;
    const id = Number(deger);
    return Number.isSafeInteger(id) && id > 0 ? id : null;
}

/** Kayıtlı takip açılmamış olsa da ekleme ekranının eski taraflarını kullanmaz. */
export function xmlAlacakliBaglami(takip: any, state: any): XmlAlacakliBaglami {
    const takipId = kayitId(takip?.id);
    let alacakli: any;
    if (takipId !== null) {
        const faizTakibi = state?.takipDetay?.faizData?.data;
        if (kayitId(faizTakibi?.id) === takipId) alacakli = faizTakibi?.alacaklilar?.[0];
        if (!alacakli) alacakli = takip?.alacaklilar?.[0];
    } else {
        alacakli = state?.takipEkle?.takipAlacaklilar?.data?.[0];
    }

    const muvekkil = alacakli?.muvekkil;
    return {
        // vekalet_no görünen dosya numarasıdır; API kayıt kimliği değildir.
        vekaletId: kayitId(muvekkil?.vekalet_id) ?? kayitId(muvekkil?.vekalet?.id)
            ?? kayitId(alacakli?.vekalet_id) ?? kayitId(alacakli?.vekalet?.id),
        kisiId: kayitId(muvekkil?.kisi_id) ?? kayitId(alacakli?.muvekkil_kisi_id),
        kurumId: kayitId(muvekkil?.kurum_id) ?? kayitId(alacakli?.muvekkil_kurum_id),
    };
}
